import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { EllipsisDropdownItem, IconButton } from "@similarweb/ui-components";

export const DropDownItem = styled(EllipsisDropdownItem)`
    svg {
        width: 100%;
        height: 100%;
    }
`;

export const AddIconButton = styled(IconButton)`
    margin-right: 8px;
`;

export const NoDataWrapper = styled.div`
    padding: 8px 0 4px 16px;
    ${setFontVariant("listSectionTitle", colorsPalettes.carbon[500])};
`;

const BaseWrapper = styled.div`
    position: absolute;
    left: 175px;
    /* Z-index value is necessary in order to stack on top of the table in the keyword research > find keywords > keyword generator tool table */
    z-index: 10;
    top: 50px;
`;

export const WarningMessageWrapper = styled(BaseWrapper)`
    max-width: 312px;
    max-height: 170px;
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 1px 1px 6px rgb(0, 0, 0, 0.24);
`;
export const NoResultsWrapper = styled.div`
    padding: 44px 30px;
    text-align: center;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;
export const SelectorContainer = styled.div`
    margin-bottom: 24px;
`;

const Title = styled.div`
    height: 20px;
    padding-bottom: 8px;
`;

export const SubTitle = styled.div`
    height: 20px;
    padding-bottom: 16px;
`;
